import { render, staticRenderFns } from "./SegAnySettings.vue?vue&type=template&id=e672699a&scoped=true"
import script from "./SegAnySettings.vue?vue&type=script&lang=js"
export * from "./SegAnySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e672699a",
  null
  
)

export default component.exports